// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function convertAuthContext(authContext) {
  var isAuthenticated = authContext.is_authenticated;
  var authUser = authContext.user;
  return {
          isAuthenticated: isAuthenticated,
          user: Belt_Option.map(authUser, (function (user) {
                  return {
                          authToken: user.auth_token,
                          mobile: user.mobile,
                          name: user.name,
                          requirementType: user.requirement_type,
                          email: user.email,
                          whatsappConsent: user.whatsapp_consent
                        };
                }))
        };
}

export {
  convertAuthContext ,
}
/* No side effect */
